export default __webpack_public_path__ + "static/media/education-icon.1751560b.svg";